/* eslint-disable */
var r = function e(t, n, i) {
  null === t && (t = Function.prototype);
  var r = Object.getOwnPropertyDescriptor(t, n);
  if (void 0 === r) {
    var o = Object.getPrototypeOf(t);
    return null === o ? void 0 : e(o, n, i)
  }
  if ("value" in r)
    return r.value;
  var a = r.get;
  return void 0 !== a ? a.call(i) : void 0
}

export default r
